/**
 * Replace translation dynamic values string.
 * This function returns value replaced string.
 */
export const setTranslationValues = (text = '', valuesObj: Record<string, string | number> = {}): string => {
  let result = text;
  for (const key in valuesObj) {
    result = result.replaceAll(`{{${key}}}`, `${valuesObj[key]}`);
  }
  return result;
};
